import React from 'react'
import { resetOpenJob, setIsNewJob } from '../store/job/actions'
import store from '../store'

export const NewJobMenuLink = ({ children }) => {
    const handleClick = () => {
        const newJob = store.getState()?.JobReducer?.newJob

        if (Object.keys(newJob?.data || {}).length > 0) {
            store.dispatch(resetOpenJob())
        }

        store.dispatch(setIsNewJob(true))
    }

    return (
        <div className="job-item" onClick={handleClick}>
            {children}
        </div>
    )
}

export default NewJobMenuLink
